import { Skeleton } from '@/components/ui/skeleton';

export function PropertyDetailSkeleton() {
  return (
    <div className="space-y-6 p-6">
      {/* Hero card skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,400px)_1fr] gap-6 rounded-lg border border-border bg-card p-6">
        <Skeleton className="h-[300px] w-full rounded-lg" />
        <div className="space-y-4">
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-8 w-2/3" />
          <Skeleton className="h-4 w-1/2" />
          <div className="flex gap-6 pt-2">
            <Skeleton className="h-12 w-16" />
            <Skeleton className="h-12 w-16" />
            <Skeleton className="h-12 w-24" />
          </div>
        </div>
      </div>

      {/* Body: tabs + orders */}
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,360px)] gap-6">
        <div className="rounded-lg border border-border bg-card p-6 space-y-6">
          <div className="flex gap-4">
            <Skeleton className="h-9 w-32" />
            <Skeleton className="h-9 w-32" />
          </div>
          <div className="grid grid-cols-3 gap-6">
            {Array.from({ length: 9 }).map((_, i) => (
              <div key={i} className="space-y-2">
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-5 w-32" />
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-lg border border-border bg-card p-6 space-y-3">
          <Skeleton className="h-6 w-24" />
          <Skeleton className="h-4 w-40" />
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-12 w-full" />
          ))}
        </div>
      </div>
    </div>
  );
}
